(() => {
  const root = document.documentElement;
  if (!root.hasAttribute('data-mx-fluid-motion')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealSelector = [
    '.mx-hero__content > *',
    '.mx-page-hero > .mx-shell > *',
    '.mx-section-heading',
    '.mx-split > *',
    '.mx-grid-2 > *',
    '.mx-grid-3 > *',
    '.mx-grid-4 > *',
    '.mx-guarantee',
    '.mx-visual-feature',
    '.mx-video-placeholder',
    '.mx-table-wrap',
    '.mx-faq details',
    '.mx-contact-panel',
    '.mx-header__bar-inner > *',
    '.mx-header__inner > *',
    '.mx-footer__grid > *',
    '.mx-footer__bottom'
  ].join(',');
  const sectionSelector = '.mx-section, .mx-proof-strip';

  const revealObserver = reducedMotion.matches || !('IntersectionObserver' in window)
    ? null
    : new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-mx-flow-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.06 });

  const sectionObserver = reducedMotion.matches || !('IntersectionObserver' in window)
    ? null
    : new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-mx-section-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.04 });

  const stage = (scope = document) => {
    const revealItems = scope.matches?.(revealSelector)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(revealSelector) || []);

    revealItems.forEach((element, index) => {
      if (element.dataset.mxFlowReady === 'true') return;
      element.dataset.mxFlowReady = 'true';
      element.classList.add('mx-flow-reveal');
      element.style.setProperty('--mx-flow-order', String(index % 5));

      if (reducedMotion.matches || !revealObserver) {
        element.classList.add('is-mx-flow-visible');
        return;
      }

      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.94 && rect.bottom > 0) {
        element.classList.add('is-mx-flow-visible');
      } else {
        revealObserver.observe(element);
      }
    });

    const sections = scope.matches?.(sectionSelector)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(sectionSelector) || []);

    sections.forEach((section) => {
      if (section.dataset.mxSectionReady === 'true') return;
      section.dataset.mxSectionReady = 'true';

      if (reducedMotion.matches || !sectionObserver) {
        section.classList.add('is-mx-section-visible');
      } else {
        sectionObserver.observe(section);
      }
    });
  };

  const boot = () => {
    stage(document);
    root.classList.add('mx-motion-ready');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => stage(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    stage(event.target);
    event.target.classList.add('is-mx-flow-visible');
  });

  document.addEventListener('pointerdown', (event) => {
    const reservoir = event.target.closest?.('.mx-button, .mx-chip, .mx-card');
    if (!reservoir) return;
    reservoir.classList.add('is-mx-liquid-filled');
    window.setTimeout(() => reservoir.classList.remove('is-mx-liquid-filled'), 720);
  }, { passive: true });

  const main = document.getElementById('MainContent');
  if (main && 'MutationObserver' in window) {
    let frame = 0;
    const mutationObserver = new MutationObserver((mutations) => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) stage(node);
          });
        });
      });
    });
    mutationObserver.observe(main, { childList: true, subtree: true });
  }
})();
